import React from "react";

const PremiumBikeWash = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold"> High Pressure Foam Wash</p>
        <ul className="list-disc text-black-500 ">
          <li>Tyre Polish</li>
          <li>Full Body Shine Coat</li>
          <li>High Pressure Foam Wash</li>
        </ul>
      </div>
    </div>
  );
};

export default PremiumBikeWash;
